<template>
  <div>
    <HomeChipError
      v-if="showError"
      :show-error.sync="showError"
      :text="errorMsg" />
    <v-form
      ref="signInForm"
      v-model="valid"
      class="d-flex flex-column"
      lazy-validation
      @submit.prevent="submit()">
      <div class="d-flex flex-column gap-1">
        <label
          for="form-login-email"
          class="secondary--text text-h3-headline">
          อีเมล
        </label>
        <v-text-field
          id="form-login-email"
          v-model="email"
          :rules="rules.email"
          outlined
          dense
          autofocus
          required></v-text-field>
      </div>
      <div class="d-flex flex-column gap-1">
        <div class="d-flex justify-space-between">
          <label
            for="form-login-pass"
            class="secondary--text text-h3-headline">
            รหัสผ่าน
          </label>
          <div
            v-ripple
            class="cs-pointer">
            <a
              href="/authen/forgot_password"
              class="primary--text text-h3-headline">
              ลืมรหัสผ่าน
            </a>
          </div>
        </div>
        <v-text-field
          id="form-login-pass"
          v-model="password"
          :rules="rules.password"
          type="password"
          autocomplete="off"
          outlined
          dense
          @keydown.enter="submit()"></v-text-field>
      </div>
      <v-btn
        :disabled="!valid"
        :loading="submitting"
        type="submit"
        color="primary"
        depressed
        rounded>
        เข้าสู่ระบบ
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { SIGN_IN_USER } from '@/resources/graphql'
import HomeChipError from './HomeChipError.vue'

export default {
  components: {
    HomeChipError
  },
  data () {
    return {
      submitting: false,
      valid: false,
      email: '',
      password: '',
      rules: {
        email: [
          (v) => !this.$_.isEmpty(v) || 'จำเป็นต้องมี',
          (v) => this.$_.isEmail(v) || 'อีเมลไม่ถูกต้อง'
        ],
        password: [(v) => !this.$_.isEmpty(v) || 'จำเป็นต้องมี']
      },
      errorMsg: '',
      showError: false
    }
  },
  methods: {
    submit () {
      if (!this.$refs.signInForm.validate()) return
      this.submitting = true
      this.$apollo
        .mutate({
          mutation: SIGN_IN_USER,
          variables: {
            input: {
              email: this.email,
              password: this.password
            }
          }
        })
        .then(({ data: { signInUser } }) => {
          const url = this.$route.query?.returnUrl || ''
          if (!this.$_.isEmpty(signInUser.errors)) {
            this.errorMsg = this.$_.head(signInUser.errors)
            this.showError = true
          } else if (!this.$_.isEmpty(signInUser.user)) {
            window.location.href = url || process.env.VUE_APP_ADWORK
          }
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>
